<template>
  <section class="c-rewards-filters">
    <fieldset class="o-fieldset c-rewards-filters__FIXME-GREGGI-WAN-OCHABI__YOURE-MY-ONLY-HOPE">
      <label class="u-label">{{ $t('web.catalog_rewards_filters.sort_by_label') }}</label>
      <select v-model="filters.sort">
        <option
          v-for  = "(option, i) in sortOptions"
          :key   = "i"
          :value = "option.value"
        >
          {{  option.name }}
        </option>
      </select>
    </fieldset>

    <fieldset class="o-fieldset c-rewards-filters__points-range">
      <label class="u-label">{{ $t('web.catalog_rewards_filters.price_range') }}</label>
      <div class="c-rewards-filters__points-range__input-layout">
        <span class="c-rewards-filters__points-range__input-layout__sub-label">{{ $t('web.catalog_rewards_filters.filter_from_points') }}</span>
        <input
          v-model     = "filters.price_min"
          class       = "c-rewards-filters__points-range__input-layout__input
                         qa-rewards-filters-low-price"
          type        = "text"
          :placeholder = "$t('web.catalog_rewards_filters.min_points_placeholder')"
        />

        <span class="c-rewards-filters__points-range__input-layout__sub-label">{{ $t('web.catalog_rewards_filters.filter_to_points') }}</span>
        <input
          v-model     = "filters.price_max"
          class       = "c-rewards-filters__points-range__input-layout__input
                         qa-rewards-filters-high-price"
          type        = "text"
          :placeholder = "$t('web.catalog_rewards_filters.max_points_placeholder')"
        />
      </div>
    </fieldset>



    <loading-icon v-if="categoriesLoading"></loading-icon>
    <div
      v-else
      class = "c-rewards-filters__category-switcher"
    >
      <div
        v-if  = "!showCategorySwitcher"
        class = "c-rewards-filters__category-switcher__default-view"
      >
        <label class="c-rewards-filters__category-switcher__default-view__label u-label">
          {{ $t('web.catalog_rewards_filters.category_label') }}
        </label>
        <h2 class = "c-rewards-filters__category-switcher__default-view__title">
          {{ selectedCategoryName }}
        </h2>

        <button
          @click = "toggleCategorySwitcher()"
          class  = "c-rewards-filters__category-switcher__default-view__button
                    u-button-as-link
                    t-link
                    qa-change-category-button"
        >
          {{ $t('web.catalog_rewards_filters.change_category_link') }}
        </button>
      </div>


      <div
        v-else
        class = "c-rewards-filters__category-switcher__change-category"
      >
        <div class="c-rewards-filters__category-switcher__change-category__header">
          <label class="u-label">{{ $t('web.catalog_rewards_filters.change_category_link') }}</label>
          <button
            @click = "toggleCategorySwitcher"
            class  = "u-button-as-link t-link"
          >
            {{ $t('web.catalog_rewards_filters.cancel_button') }}
          </button>
        </div>

        <ul>
          <li
            class = "o-radio
                     o-radio--area-selector
                     o-radio--no-transitions
                     c-rewards-filters__category-switcher__change-category__radio-item
                     qa-category-option"
          >
            <input
              v-model = "filters.category"
              value   = ""
              @click  = "selectCategory"
              class   = "o-radio__input"
              type    = "radio"
              name    = "filterCategory"
            />
            <label class="o-radio__label">{{ $t('web.catalog_rewards_filters.no_category') }}</label>
          </li>

          <li
            v-for = "category in $store.getters.categories"
            class = "o-radio
                     o-radio--area-selector
                     o-radio--no-transitions
                     c-rewards-filters__category-switcher__change-category__radio-item
                     qa-category-option"
          >
            <input
              v-model = "filters.category"
              :value  = "category.code"
              @click  = "selectCategory(category)"
              class   = "o-radio__input"
              type    = "radio"
              name    = "filterCategory"
            />
            <label class="o-radio__label">{{ getCategoryName(category) }}</label>
          </li>
        </ul>
      </div>
    </div>




    <div
      v-show = "showRewardFilters"
      class  = "c-rewards-filters__filter-checkboxes"
    >
      <loading-icon v-if="filtersLoading"></loading-icon>
      <div
        v-else
        v-for  = "filter in $store.getters.rewardFilters"
        v-show = "filter.options.length"
      >
        <label class="c-rewards-filters__filter-checkboxes__section-label u-label">
          {{ getFilterName(filter) }}
        </label>
        <ul>
          <li
            class = "o-checkbox
                     o-checkbox--area-selector
                     c-rewards-filters__filter-checkboxes__checkbox-item
                     qa-filter-option"
            v-for = "option in filter.options"
          >
            <input
              type    = "checkbox"
              class   = "o-checkbox__input"
              v-model = "filters[getFiltersKeyFor(filter)]"
              :value = "getOptionValueFor(option)"
            />
            <label class="o-checkbox__label">{{ getOptionNameFor(option) }}</label>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>




<script>
import { clone, find, get, isArray, isObject, mapValues, merge, omitBy } from 'lodash'
import { mapGetters } from 'vuex'

const initFilters = {
  category: null,
  price_min: null,
  price_max: null,
  sort: ''
}

export default {
  name: 'RewardsFilters',

  data () {
    return {
      categoriesLoading: true,
      filters: clone(initFilters),
      filtersLoading: false,
      showCategorySwitcher: false,
      sortOptions: [
        {
          name: this.$t('web.catalog_rewards_filters.sort_default'),
          value: ''
        },
        {
          name: this.$t('web.catalog_rewards_filters.sort_points_desc'),
          value: 'member_sale_price,descending'
        },
        {
          name: this.$t('web.catalog_rewards_filters.sort_points_asc'),
          value: 'member_sale_price,ascending'
        },
        {
          name: this.$t('web.catalog_rewards_filters.sort_name_asc'),
          value: 'name,ascending'
        },
        {
          name: this.$t('web.catalog_rewards_filters.sort_name_desc'),
          value: 'name,descending'
        },
        {
          name: this.$t('web.catalog_rewards_filters.sort_age_asc'),
          value: 'created_date,descending'
        },
        {
          name: this.$t('web.catalog_rewards_filters.sort_age_desc'),
          value: 'created_date,ascending'
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'participant'
    ]),

    /**
     * Get filters that have values filled.
     *
     * @return {object}
     */
    filledFilters () {
      return omitBy(this.filters, value => {
        return isArray(value) ? !value.length : !value
      })
    },

    /**
     * Determine whether the reward filters should be shown.
     *
     * @return {boolean}
     */
    showRewardFilters () {
      return Boolean(!this.showCategorySwitcher && this.selectedCategory)
    },

    /**
     * Get the currently selected category.
     *
     * @return {object}
     */
    selectedCategory () {
      /** Categories' codes can be numeric (ids) */
      return this.filters.category
        ? find(this.$store.getters.categories, category => category.code.toString() === this.filters.category.toString())
        : undefined
    },

    /**
     * Get the name for the selected category.
     *
     * @return {string}
     */
    selectedCategoryName () {
      return this.getCategoryName(this.selectedCategory) || this.$t('web.catalog_rewards_filters.no_category')
    }
  },

  methods: {
    /**
     * Get the name of the filter.
     *
     * @param {object} filter This comes from the GET_REWARD_FILTERS action.
     * @return {string}
     */
    getFilterName (filter) {
      if (filter.hasOwnProperty('property_key')) {
        return this.$t(`web.catalog_rewards_filters.${filter.property_key}_label`)
      }

      /*
        for some reason, the brands label seems to be the only filter
        that does not have a property_key nor a property_name ¯\_(ツ)_/¯
      */
      return this.$t('web.catalog_rewards_filters.brands_label')
    },

    /**
     * Get the name of the key to use in this.filters for a specific filter.
     *
     * Brands use the filter name; properties use the filter key.
     *
     * TODO Format the response from MagicLamp to remove this distinction and make this call unnecessary.
     *
     * @param {object} filter This comes from the GET_REWARD_FILTERS action.
     * @return {string}
     */
    getFiltersKeyFor (filter) {
      return filter.type === 'Label::Brand'
        ? 'brands'
        : (filter.property_key || filter.property_name).toLowerCase()
    },

    /**
     * Get the name to use for a specific option in a filter group.
     *
     * TODO Format the response from MagicLamp to remove this distinction and make this call unnecessary.
     */
    getOptionNameFor (option) {
      return option.name || option.value
    },

    /**
     * Get the value to use for a specific option in a filter group.
     *
     * Brands use the option ID; properties use the option value.
     *
     * TODO Format the response from MagicLamp to remove this distinction and make this call unnecessary.
     *
     * @param {object} option This comes from the GET_REWARD_FILTERS action.
     * @return {string|number}
     */
    getOptionValueFor (option) {
      return option.id || option.value
    },

    getCategoryName (category) {
      return isObject(category) && isObject(category.name)
        ? get(category, 'name.' + this.participant.catalog_locale, '')
        : get(category, 'name', null)
    },

    /**
     * Toggle the visibility of the category switcher.
     *
     * @return {void}
     */
    toggleCategorySwitcher () {
      this.showCategorySwitcher = !this.showCategorySwitcher
    },

    /**
     * Clear the selected filters.
     *
     * @return {void}
     */
    clearFilters () {
      this.filters = clone(initFilters)
    },

    /**
     * Apply the filled filters.
     *
     * @return {void}
     */
    applyFilters () {
      this.$router.push({
        name: this.$route.name,
        query: mapValues(
          this.$route.query.search
            ? merge(this.filledFilters, { search: this.$route.query.search })
            : this.filledFilters,
          value => {
            // Comma-separate array values.
            return isArray(value) ? value.join(',') : value
          }
        )
      })
    },

    /**
     * Select a category.
     *
     * @param {Object} category Selected category object.
     * @return {void}
     */
    selectCategory (category) {
      this.clearFilters()
      this.getRewardCategoryFilters()
      this.toggleCategorySwitcher()
      // NOTE In most browsers, we can rely on the v-model attribute on the radio buttons, but IE 11
      //      and Edge fire change/click events in the opposite order as other browsers, requiring
      //      this workaround.
      this.filters.category = category.code
    },

    /**
     * Load the filters for the selected category.
     *
     * @return {void}
     */
    getRewardCategoryFilters () {
      this.$nextTick(() => {
        this.filtersLoading = true
        this.$store.dispatch('GET_REWARD_FILTERS', { category: this.filters.category })
          .then(() => {
            this.filtersLoading = false
          })
          .catch(error => Promise.reject(error))
      })
    },

    /**
     * Set each relevant key for this.filters to empty arrays.
     *
     * This resets any previously selected values and ensures that the checkboxes'
     * v-model/value attributes are handled properly.
     *
     * @return {void}
     */
    setKeysForFilters () {
      this.$store.getters.rewardFilters.forEach(rewardFilter => {
        const filterName = rewardFilter.type === 'Label::Brand'
          ? 'brands'
          : (rewardFilter.property_key || rewardFilter.property_name).toLowerCase()

        this.$set(
          this.filters,
          filterName,
          // This method should use query parameters only once, which ensures
          // applied filters are set in the UI if a user visits the page from
          // a bookmark, but filters don't persist when switching categories.
          this.keysForFiltersSetPreviously || !get(this.$route.query, filterName, []).length
            ? []
            : this.$route.query[filterName].split(',')
        )
      })

      // This property isn't set on the component's data object, because it
      // doesn't require reactivity.
      this.keysForFiltersSetPreviously = true
    }
  },

  watch: {
    '$store.getters.rewardFilters' () {
      this.setKeysForFilters()
    },
    // clear filters except category if within a category when searching
    '$route.query.search' () {
      this.clearFilters()
      this.setKeysForFilters()
      this.filters.category = this.$route.query.category || null
    },
    // updates category when selected from search dropdown
    '$route.query.category' () {
      this.filters.category = this.$route.query.category || null
    }
  },

  created () {
    // Set initial filter values if already present in query parameters.
    Object.keys(initFilters).forEach(filter => {
      // The fallback here keeps this from overriding set values for filters
      // powered by select inputs.
      this.filters[filter] = this.$route.query[filter] || this.filters[filter]
    })

    // Load category-specific filters if category already selected.
    if (this.filters.category) {
      this.getRewardCategoryFilters()
    }

    // Load categories.
    this.$store.dispatch('GET_CATEGORIES')
      .then(() => {
        this.categoriesLoading = false
      })
      .catch(error => Promise.reject(error))
  }
}
</script>




<style lang="sass">
  .c-rewards-filters__FIXME-GREGGI-WAN-OCHABI__YOURE-MY-ONLY-HOPE
    border-bottom: 1px dotted #dce0dc
    margin-bottom: 15px
    padding: 0 15px 30px
</style>



// WEBPACK FOOTER //
// RewardsFilters.vue?d2e0216e